import { render, staticRenderFns } from "./MultiselectTag.vue?vue&type=template&id=73cc22e8&"
import script from "./MultiselectTag.vue?vue&type=script&lang=js&"
export * from "./MultiselectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports